jQuery(($) => {

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Browser - Keydown Focus Class
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $("body").on("keydown", function () {
        if (!$(".keyboard-in-use")[0]) {
            $(this).addClass("keyboard-in-use");
        }
    }); 

    $("body").on("mousedown", function () {
        if ($(".keyboard-in-use")[0]) {
            $(this).removeClass("keyboard-in-use");
        }
    }); 


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ CTA Block Image Slider Hero
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    if ($('.o-cta-block-image-slider-hero--slider')[0]) {
        $('.o-cta-block-image-slider-hero__block-slides').slick({
            speed: 600,
            cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
            fade: true,
            arrows: false,
            dots: false
        });

        if ($('.o-cta-block-image-slider-hero__image-slides')[0]) {
            $('.o-cta-block-image-slider-hero__image-slides').slick({
                speed: 600,
                infinite: true,
                cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)', 
                fade: true,
                dots: true,
                arrows: true,
                appendArrows: $('.o-cta-block-image-slider-hero__arrows-navigation'),
                asNavFor: $('.js-slider-controlled')
            });
        } 

        if ($('.o-cta-block-image-slider-hero__pagination')[0]) {
            $('.o-cta-block-image-slider-hero__pagination').slick({
                speed: 400,
                fade: true,
                arrows: false,
            });
        }
    }
}); 
